import React, { createContext, useContext, useState, useEffect } from 'react';

const DataContext = createContext();

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  const [savedCostBreakdowns, setSavedCostBreakdowns] = useState([]);
  const [savedVisualizations, setSavedVisualizations] = useState([]);
  const [savedComponents, setSavedComponents] = useState([]);
  const [savedProperties, setSavedProperties] = useState([]);

  useEffect(() => {
    const savedCostData = localStorage.getItem('savedCostBreakdowns');
    const savedVizData = localStorage.getItem('savedVisualizations');
    const savedCompData = localStorage.getItem('savedBlendComponents');
    const savedPropsData = localStorage.getItem('savedProperties');

    if (savedCostData) setSavedCostBreakdowns(JSON.parse(savedCostData));
    if (savedVizData) setSavedVisualizations(JSON.parse(savedVizData));
    if (savedCompData) setSavedComponents(JSON.parse(savedCompData));
    if (savedPropsData) setSavedProperties(JSON.parse(savedPropsData));
  }, []);

  const saveCostBreakdown = (costData) => {
    const newCostBreakdown = {
      id: Date.now(),
      name: `Cost Breakdown ${new Date().toLocaleString()}`,
      ...costData,
      timestamp: Date.now()
    };

    const updated = [...savedCostBreakdowns, newCostBreakdown];
    setSavedCostBreakdowns(updated);
    localStorage.setItem('savedCostBreakdowns', JSON.stringify(updated));
    return newCostBreakdown;
  };

  const saveVisualization = (vizData) => {
    const newVisualization = {
      id: Date.now(),
      name: `Blend Visualization ${new Date().toLocaleString()}`,
      ...vizData,
      timestamp: Date.now()
    };

    const updated = [...savedVisualizations, newVisualization];
    setSavedVisualizations(updated);
    localStorage.setItem('savedVisualizations', JSON.stringify(updated));
    return newVisualization;
  };

  const saveComponents = (componentsData) => {
    const newComponents = {
      id: Date.now(),
      name: `Components ${new Date().toLocaleString()}`,
      ...componentsData,
      timestamp: Date.now()
    };

    const updated = [...savedComponents, newComponents];
    setSavedComponents(updated);
    localStorage.setItem('savedBlendComponents', JSON.stringify(updated));
    return newComponents;
  };


  const saveProperties = (propertiesData) => {
  const newProperties = {
    id: Date.now(),
    name: propertiesData.customName || `Properties ${new Date().toLocaleString()}`,
    properties: propertiesData.properties,
    count: propertiesData.properties.length,
    timestamp: propertiesData.timestamp || Date.now(),
    customName: propertiesData.customName 
  };

  const updated = [...savedProperties, newProperties];
  setSavedProperties(updated);
  localStorage.setItem('savedProperties', JSON.stringify(updated));
  return newProperties;
};

  const deleteCostBreakdown = (id) => {
    const updated = savedCostBreakdowns.filter(item => item.id !== id);
    setSavedCostBreakdowns(updated);
    localStorage.setItem('savedCostBreakdowns', JSON.stringify(updated));
  };

  const deleteVisualization = (id) => {
    const updated = savedVisualizations.filter(item => item.id !== id);
    setSavedVisualizations(updated);
    localStorage.setItem('savedVisualizations', JSON.stringify(updated));
  };

  const deleteComponents = (id) => {
    const updated = savedComponents.filter(item => item.id !== id);
    setSavedComponents(updated);
    localStorage.setItem('savedBlendComponents', JSON.stringify(updated));
  };

  const deleteProperties = (id) => {
    const updated = savedProperties.filter(item => item.id !== id);
    setSavedProperties(updated);
    localStorage.setItem('savedProperties', JSON.stringify(updated));
  };

  const value = {
    savedCostBreakdowns,
    savedVisualizations,
    savedComponents,
    savedProperties,
    saveCostBreakdown,
    saveVisualization,
    saveComponents,
    saveProperties,
    deleteCostBreakdown,
    deleteVisualization,
    deleteComponents,
    deleteProperties
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};